import { replace } from 'react-router-redux';

import { setWindowLocation } from '@eb/http';
import { trackEventFromState } from '@eb/site-analytics';

import {
    GA_AUTH_CATEGORY,
    GA_CONFIRMATION_ACKNOWLEDGED,
    GA_CONFIRMATION_REJECTED,
} from '../constants';

// Signin Confirmation Actions
export const acknowledgeMessage = () => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_CONFIRMATION_ACKNOWLEDGED,
        category: GA_AUTH_CATEGORY,
    });
    dispatch(replace('/signin'));
};

export const rejectMessage = (forwardURL) => (dispatch, getState) => {
    trackEventFromState(getState(), {
        action: GA_CONFIRMATION_REJECTED,
        category: GA_AUTH_CATEGORY,
    });
    setWindowLocation(forwardURL);
};
